import React from 'react'
import { Button, DataListItem, Icon, Tooltip } from '@node-space/ui-components'

export interface LegalAgreementDetailLinkProps {
  id: string
  title: string
  tooltipText?: string
  filename: string
  url: string
}

export const LegalAgreementDetailLink = ({
  id,
  title,
  tooltipText,
  filename,
  url,
}: LegalAgreementDetailLinkProps) => {
  return (
    <DataListItem
      id={id}
      title={title}
      {...(tooltipText && { Tooltip: <Tooltip bodyContent={tooltipText} /> })}
      body=""
      ActionButtons={[
        <Button
          key="link"
          noPadding
          variant="ghost"
          iconElement={<Icon name="ArrowSquareOut" />}
          iconPosition="right"
          onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
        >
          {filename}
        </Button>,
      ]}
    />
  )
}
